// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'tablet-rate';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.817 7.854h1.91l1.146-1.529L9.402 9l1.146-1.528h2.128' />
    <path d='M13.78 1.231H4.22c-.66 0-1.196.536-1.196 1.196v13.146c0 .66.535 1.195 1.195 1.195h9.561c.66 0 1.196-.535 1.196-1.195V2.427c0-.66-.535-1.196-1.196-1.196zM8.104 13.78h1.792' />
  </g>
);

export const viewBox = '0 0 18 18';
